import { TestIntegrationRequest, TestIntegrationResponse } from '@/@types/Integrations';
import { api } from './api';

async function getIntegration({ integration, page }) {
  const response = await api.get(
    `/v1/integrations?integration=${integration}&page=${page}`,
    { timeout: 15000 }
  );

  return response.data;
}

async function createIntegration({ data, integration }) {
  if (integration === 'red_rock') {
    const response = await api.post('/v1/integrations', {
      ...data,
      integration,
    });

    return response.data;
  }

  const response = await api.post(
    `/v1/integrations?integration=${integration}`,
    data
  );

  return response.data;
}

async function updateIntegration({ data, integration }) {
  const response = await api.post(`/v1/integrations/${data.id}`, data);

  return response.data;
}

async function deleteIntegration(id: string) {
  const response = await api.delete(`/v1/integrations/${id}`);

  return response.data;
}

async function getCoursesMemberkit(access_token: string) {
  const response = await api.post('/v1/integrations/member-kit', {
    access_token,
  });

  return response.data;
}

async function getActiveCampaignLists({
  access_token,
  postback_url,
  q,
  list_id,
}: {
  access_token: string;
  postback_url: string;
  q?: string;
  list_id?: number;
}) {
  const response = await api.post<{ data: { id: string; name: string }[] }>(
    '/v1/integrations/active-campaign',
    {
      access_token,
      postback_url,
      ...(q?.trim() && { q: q.trim() }),
      ...(list_id !== undefined && { list_id }),
    }
  );

  return response.data;
}

async function getWebhooksHistory(params) {
  const { page, startDate, endDate, q, status, integrations } = params;
  const urlParams = new URLSearchParams();

  if (page !== undefined) urlParams.append('page', page.toString());
  if (startDate !== undefined) urlParams.append('start_date', startDate);
  if (endDate !== undefined) urlParams.append('end_date', endDate);
  if (status !== undefined) urlParams.append('status', status);
  if (integrations !== undefined)
    urlParams.append('integrations', integrations);

  if (q && q.length > 1) {
    urlParams.append('q', q);
  }

  const response = await api.get(
    `/v1/webhooks/ingests?${urlParams.toString()}`
  );

  return response.data;
}

async function retrySendingWebhook(id: string) {
  const response = await api.post(`/v1/webhooks/ingests/${id}/retry`);
  return response.data;
}

async function getWebhookDetails(uuid: string) {
  const response = await api.get(`/v1/webhooks/ingests/${uuid}`);
  return response.data;
}

async function testIntegration(data: TestIntegrationRequest): Promise<TestIntegrationResponse> {
  const response = await api.post('/v1/integrations/test', data);
  return response.data;
}

export const IntegrationsService = {
  getIntegration,
  createIntegration,
  updateIntegration,
  deleteIntegration,
  getCoursesMemberkit,
  getWebhooksHistory,
  getActiveCampaignLists,
  retrySendingWebhook,
  getWebhookDetails,
  testIntegration,
};
